import { Indicator, Text as MantineText } from '@mantine/core';
import { IconListCheck } from '@tabler/icons';
import { FC, useContext } from 'react';
import { ProfileContext } from '../../../Service/Context/ProfileContext';

const ListCheckIconWithIndicator: FC = () => {
  const { overdueTasks } = useContext(ProfileContext);
  const count = overdueTasks?.count ?? 0;

  return (
    <Indicator
      inline
      disabled={count < 1}
      radius="xl"
      offset={-2}
      size={20}
      color="red"
      label={
        <MantineText color="white" size={10}>
          {count}
        </MantineText>
      }
    >
      <IconListCheck />
    </Indicator>
  );
};

export default ListCheckIconWithIndicator;
